import { NgcCookieConsentConfig } from 'ngx-cookieconsent';

export const COOKIE_CONSENT_CONFIG: NgcCookieConsentConfig = {
  autoOpen: false,
  cookie: {
    domain: ''
  },
  palette: {
    popup: {
      background: '#1f2235'
    },
    button: {
      background: '#ef233c'
    }
  },
  theme: 'classic',
  type: 'opt-out',
  content: {
    message: 'This website uses cookies to improve your experience.',
    dismiss: 'Accept',
    deny: 'Decline',
    link: 'Privacy Policy',
    href: '/privacy-policy'
  }
};
